import { ReactNode, useMemo } from 'react';
import useRegistrationLifecycle from '@/hooks/registration/useRegistrationLifecycle';
import { RegistrationLifecycleContext } from './registrationLifecycleContext';

export const RegistrationLifecycleProvider = ({ children }: { children: ReactNode }) => {
    const { formatUtcToStoreTime, refreshTable, refreshRegistrationNow } = useRegistrationLifecycle();

    const value = useMemo(
        () => ({
            formatUtcToStoreTime,
            refreshTable,
            refreshRegistrationNow,
        }),
        [formatUtcToStoreTime, refreshTable, refreshRegistrationNow],
    );

    return <RegistrationLifecycleContext.Provider value={value}>{children}</RegistrationLifecycleContext.Provider>;
};
